// Terms of use page

import React from 'react'

function TermsOfUse() {
  return (
    <div>
      Terms of use page.
    </div>
  )
}

export default TermsOfUse
